import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import {
  customPageDownloadUrl,
  customPageHtmlFileName,
  downloadCustomPageMetadata,
} from '../util/customPages';

function CustomPage() {
  const { pageId, path } = useParams();
  const [frameSource, setFrameSource] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!pageId || !path) {
      setFrameSource(null);
      return;
    }

    setLoading(true);
    setFrameSource(null);
    downloadCustomPageMetadata(path, pageId)
      .then((metadata) => {
        const nextUrl = metadata.iframeUrl?.trim() ?? '';
        setFrameSource(
          nextUrl.length > 0
            ? nextUrl
            : customPageDownloadUrl(path, customPageHtmlFileName(pageId))
        );
      })
      .catch((_error: Error) => {
        setFrameSource(customPageDownloadUrl(path, customPageHtmlFileName(pageId)));
      })
      .finally(() => setLoading(false));
  }, [pageId, path]);

  return (
    <>
      <Header />

      {pageId && path && (
        <div className='h-full grow'>
          {loading && <div className="mb-4">Načítavam...</div>}
          {frameSource && (
          <iframe
              src={frameSource}
              className="w-full h-full"
              style={{ border: 'none' }}
            />
          )}
        </div>
      )}
    </>
  );
}

export default CustomPage;
